import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { Navbar } from './components/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { VideoPreview } from './pages/VideoPreview';
import VideoEditor from './pages/VideoEditor';
import { VideoList } from './pages/VideoList';
import { TestPlayer } from './pages/TestPlayer/TestPlayer';
import { EmbedPlayer } from './pages/EmbedPlayer/EmbedPlayer';

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path='/player/:id'>
          <Navbar title={'KULUM'} />
          <VideoPreview />
        </Route>
        <Route path='/editor/:id'>
          <Navbar title={'KULUM'} />
          <VideoEditor />
        </Route>
        <Route path='/embed/:id'>
          <EmbedPlayer />
        </Route>
        <Route path='/test'>
          <Navbar title={'KULUM'} />
          <TestPlayer />
        </Route>
        <Route path='/'>
          <Navbar title={'KULUM'} />
          <VideoList />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
